import { Injectable } from '@angular/core';
import { AssetMaintenanceRecordsService } from '../asset-maintenance-records/asset-maintenance-records.service';
import { UtilsService } from '../../shared/utils.service';

@Injectable({
  providedIn: 'root'
})
export class AssetMaintenanceSchedulesService {
  readonly SCHEDULE_MODES: Record<string, string> = {
    date: 'Date'
  };

  readonly AUTO_CREATE_LEAD_TIME_UNITS: Record<string, string> = {
    hours: 'Hours',
    days: 'Days',
    weeks: 'Weeks'
  };

  constructor(
    public utils: UtilsService,
    public assetMaintenanceRecordsService: AssetMaintenanceRecordsService
  ) {}

  getScheduleModeLabel(value: string | null | undefined): string {
    return this.utils.getLabel(this.SCHEDULE_MODES, value);
  }

  getMaintenanceTypeLabel(value: string | null | undefined): string {
    return this.assetMaintenanceRecordsService.getTypeLabel(value);
  }

  getPriorityLabel(value: string | null | undefined): string {
    return this.assetMaintenanceRecordsService.getPriorityLabel(value);
  }

  isOtherType(value: string | null | undefined): boolean {
    return value === 'other';
  }
}
